import React from "react";
import Light from "components/headers/light";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaPhoneAlt, FaInstagram, FaEnvelope } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import Footerr from "components/footers/Footer";

const Contact = () => {
      const { t } = useTranslation();
  
  return (
    <AnimationRevealPage>
      <Light />

      {/* Section Titre "À propos" */}
      <div
 style={{
  width: "100vw",
  marginInlineStart: "calc(50% - 50vw)",
  marginInlineEnd: 0,
  // backgroundColor: "#f8e7ee", // rose clair
  padding: "80px 0",
  textAlign: "center",
  height: "300px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}}

>
  <h1
    style={{
      color: "#000000",
      fontWeight: "bold",
      fontSize: "52px",
      margin: 0,
    }}
  >
    {t('Contactez-Nous')}
  </h1>
</div>

<p
  className="text-center"
  style={{
    color: "#4e7662",
    fontSize: "22px",
    fontFamily: "Urbanist",
    marginBottom: "40px",
    marginTop: "-40px"
  }}
>
  {t('contact.client_team')}
</p>
      <div style={{ backgroundColor: "#fffff", padding: "60px 0" }}>
        <div style={{ width: "100%", maxWidth: "100%", margin: 0 }}>
          <Row className="g-4 justify-content-center m-0">
            {/* Phone */}
            <Col xs={12} md={4}>
              <Card className="p-4 border-0 shadow-sm text-center d-flex align-items-center justify-content-center h-100">
                <FaPhoneAlt size={30} color="#4e7662" className="mb-3" />
                <h5 className="mb-0 text-muted"> 0661-653922</h5>
                <h5 className="mb-0 text-muted">0661-653922</h5>

              </Card>
            </Col>

            {/* Instagram */}
            <Col xs={12} md={4}>
              <Card className="p-4 border-0 shadow-sm text-center d-flex align-items-center justify-content-center h-100">
                <FaInstagram size={30} color="#4e7662" className="mb-3" />
                <a
      href="https://www.instagram.com/rehabbiocosmetiques/"
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "#4e7662" }}
    >
      <h5 className="mb-0" style={{ color: "#4e7662" }}>
        rehabbiocosmetiques
      </h5>
    </a>

              </Card>
            </Col>

            {/* Email */}
            <Col xs={12} md={4}>
              <Card className="p-4 border-0 shadow-sm text-center d-flex align-items-center justify-content-center h-100">
                <FaEnvelope size={30} color="#4e7662" className="mb-3" />
                <h5 className="mb-0 text-muted">contact@rehabbio.ma</h5>
              </Card>
            </Col>
          </Row>
        </div>
      </div>


      <Footerr />
    </AnimationRevealPage>
  );
};

export default Contact;
